export function validate(forms, values) {
  const result = [];
  forms.forms.map((v, k) => {
    v.values.fields.forEach((item, i) => {
      if (!item.optional) {
        const value = values[item.name];
        switch (item.validation) {
          case "has":
            if (!value || (value && value.length < 1)) {
              result.push({ name: item.name });
            }
            break;
          case "number":
            if (!value || (value && isNaN(value))) {
              result.push({ name: item.name });
            }
            break;
          case "selected":
            if (!value || (value && value.length < 1)) {
              result.push({ name: item.name });
            }
            break;
        }
      }
    });
  });

  return result;
}

export function getValuesFromName(values, name) {
  let v = values[name];
  return v;
}

export function nextStep(step, values) {
  switch (step) {
    case 1:
      if (values[0].FirstName == "Emilio") {
        return step + 1;
      } else {
        return 0;
      }
      break;
    default:
      return step + 1;
  }
}

export function checkForStep(operator, value, control, stepTrue, stepFalse) {
  // Example "nextstep": "check:<:Membrinucleo:2:f9:f1",
  switch (operator) {
    case "<":
      if (value < control) {
        return stepTrue;
      } else {
        return stepFalse;
      }
      break;
    default:
      console.log("ATTENTION!!! Default check function value.");
      return stepFalse;
  }
}

export function switchForStep(v, text, response) {
  const cases = JSON.parse(text);
  for (const caseItem of cases) {
    const evalExpression = transformHyphenatedPropertyAccess(caseItem.eval);
    if (eval(evalExpression)) {
      return caseItem.step;
    }
  }
  console.log("Problem here...at least one should be true.");
}

/**
 * Transforms property accessors with hyphens from dot notation to bracket notation.
 * This is necessary because JavaScript interprets hyphens in property names as subtraction
 * when using dot notation in eval().
 *
 * Example:
 * - Input:  "v.member_8b5978ea-d64a-4bdd-8e66-2ef9e8e45a88_field"
 * - Output: "v[\"member_8b5978ea-d64a-4bdd-8e66-2ef9e8e45a88_field\"]"
 */
export function transformHyphenatedPropertyAccess(evalString) {
  if (typeof evalString !== "string") {
    return evalString;
  }

  // Pattern matches: v.property_name_with-possible-hyphens_more_text
  // We need to capture property names that contain hyphens after "v."
  const transformedString = evalString.replace(
    /v\.([a-zA-Z_][a-zA-Z0-9_]*(?:-[a-zA-Z0-9_]+)+[a-zA-Z0-9_]*)/g,
    function replaceDotNotationWithBracket(_, propertyName) {
      return `v["${propertyName}"]`;
    }
  );

  return transformedString;
}

export function getIdFromForm(forms, name) {
  let id = 0;

  forms.forEach((item, i) => {
    if (item.name === name) {
      id = i;
    }
  });

  return id;
}

export function getFormByName(forms, name) {
  const id = getIdFromForm(forms, name);
  return forms[id];
}

export function getNextForm(forms, current, direction) {
  const id = getIdFromForm(forms, current);
  if (direction === "FORWARD") {
    if (id + 1 >= forms.length) return forms[id];
    return forms[id + 1];
  }

  if (direction === "BACKWARD") {
    if (id === 0) return forms[id];
    return forms[id - 1];
  }

  return forms[id];
}

export function getFieldsFromStep(forms, activeStepName) {
  for (const form of forms) {
    for (const section of form.sections) {
      const step = section.forms.find((form) => form.stepname === activeStepName);
      if (step) return step.fields;
    }
  }

  return [];
}

export function openLinkSupportCtrl(linkInput, event) {
  if (event.ctrlKey || event.metaKey) {
    if (linkInput) window.open(linkInput || "", "_blank", "noopener noreferrer");
    return true;
  }
  return false;
}
